<template>
  <div class="home">
    <Home/>
  </div>
</template>

<script>
// @ is an alias to /src
import Home from 'place/home/home.vue'

export default {
  name: 'home',
  components: {
    Home
  }
}
</script>
